import { MessageStatus } from '@nexus/lib-react/dist/core/Banner/Banner';
import React, { memo } from 'react';
import { Dac7Data } from 'typings/dac7';
import { useI18n } from '@olxeu-a2b/ui/src/i18n';
import formatDac7Deadline from '../utils/formatDac7Deadline';
import {
  Dac7BannerLink,
  Dac7BannerText,
  Dac7BannerTitle,
  Dac7BannerContainer,
} from './style/Dac7Banner';

interface Dac7BannerProps {
  dac7Data: NonNullable<Readonly<Dac7Data>>;
  isDesktop: boolean;
  withLink?: boolean;
}

const Dac7Banner = ({ dac7Data, isDesktop, withLink }: Dac7BannerProps) => {
  const i18n = useI18n();

  const { deadline, isBlockable, blockedAt, details, submittedAt } = dac7Data;

  const showWarningBanner = !!deadline && isBlockable && !submittedAt && !blockedAt;
  const showBlockedBanner = !!blockedAt && !submittedAt;
  const formattedDeadline = deadline && formatDac7Deadline(deadline);

  // Seller's payout account is not blocked yet as deadline hasn't passed. Show warning banner.
  if (showWarningBanner) {
    const message = (
      <>
        <Dac7BannerTitle>
          {i18n`dlv_dac7_top_banner_warning_bold_text`} {formattedDeadline}
        </Dac7BannerTitle>
        <Dac7BannerText>{i18n`dlv_dac7_top_banner_warning_description`}</Dac7BannerText>
        {withLink && (
          <Dac7BannerLink
            href={details.deepLink}
          >{i18n`dlv_dac7_top_banner_link_text`}</Dac7BannerLink>
        )}
      </>
    );
    return (
      <Dac7BannerContainer type={MessageStatus.WARNING} noIcon={!isDesktop} message={message} />
    );
  }

  // Seller's payout account is blocked and the deadline to submit data has passed. Show blocked banner.
  if (showBlockedBanner) {
    const message = (
      <>
        <Dac7BannerTitle>{i18n`dlv_dac7_top_banner_blocked_bold_text`}</Dac7BannerTitle>
        <Dac7BannerText>{i18n`dlv_dac7_top_banner_blocked_description`}</Dac7BannerText>
        {withLink && (
          <Dac7BannerLink
            href={details.deepLink}
          >{i18n`dlv_dac7_top_banner_link_text`}</Dac7BannerLink>
        )}
      </>
    );

    return <Dac7BannerContainer message={message} type={MessageStatus.ERROR} noIcon={!isDesktop} />;
  }

  return <></>;
};

export default memo(Dac7Banner);
